import { sharedCommon } from "@shared/locales/en/US/sharedCommon";

export const common = {
  ...sharedCommon,
  HaveAcount: "Already have an account?",
  WhereAreYouLocated: "Where are you located?",
  SelectYourAccountType: "Select your account type.",
  HaveExistingEmersonAccount:
    "You have an existing Emerson Ecologics account and it will be used to access Fullscript.",
  SignIn: "Sign in",
  EmailAlreadyExists: "An account with this email exists, <2>sign in to continue</2>",
  LengthValidation: "Must be at least 8 characters long",
  LengthConfirmation: "Password is 8+ characters long",
  FirstName: "First name",
  LastName: "Last name",
  PracticeName: "Practice name",
  DesignationSearch: "Search for your health profession",
  DesignationNoResults: "No results found",
  pleaseSelectDesignation: "Please select your health profession",
  FirstNameRequired: "First name is required",
  FirstNameInvalid: "First name can't be a url",
  PracticeNameDefaultWithPlatform: "{{- fullName}} {{storePlatform}} Account",
  PracticeNameDefault: "{{- fullName}} Fullscript Account",
  PracticeDisplayName: "{{- fullName }} Practice",
  PracticeNameInvalid: "Practice name can't be a url",
  PracticeNameTooShort: "Practice name is too short",
  EditOnceSignedIn: "You can edit this information once you are signed in",
  LastNameRequired: "Last name is required",
  LastNameInvalid: "Last name can't be a url",
  CreateMyAccount: "Create my account",
  CreateAccount: "Create account",
  IAmA: "I am a ...",
  IAmAPatient: "I'm a patient,",
  FindInvite: "find my invite.",
  Password: "Password",
  TermsOfServiceAndPrivacyStatement:
    "By creating your account you agree to our <2>Terms of Service</2> and <4>Privacy Statement</4>",
  TermsOfServiceCheckboxLabel:
    "I agree to Fullscript's <tos>Terms of Service</tos> and <privacy>Privacy Statement</privacy>",
  TermsOfServiceWithExistingEmersonAccount: "By activating your account you agree to our ",
  Or: "Or",
  WeRequireType: "Required so we can tailor your experience accordingly",
  Search: "Search...",
  PasswordPrompt: "Input your password to continue",
  emailInUse: "This email is already in use. Try <1>sign in</1> or <3>forgot password</3> instead",
  Terms: "I agree to {{platform}} <2>{{terms}}</2> and <4>{{privacy}}</4>",
  Fullscript: "Fullscript's",
  EmersonEcologics: "Emerson Ecologics'",
  Emerson: {
    PracticeName: "Business name",
    PracticeNameInvalid: "Business name can't be a url",
    PracticeNameTooShort: "Business name is too short",
  },
  PracAcccount: "Practitioner account",
  PatientAccount: "Patient account",
  RecommendSupplementsAndLabs: "Recommend supplements and labs to your patients.",
  RecommendSupplements: "Recommend supplements to your patients.",
  AccessrSupplements: "Access supplements recommended by your practitioner.",
  OrderSupplementsAndLabs: "Order supplements, labs, and track your results.",
  RupaRecommendLabsAndSupplements: "Recommend labs and supplements to your patients.",
  RupaOrderLabsAndSupplements:
    "Order labs and supplements as part of your treatment plan, and track your results along the way.",
  GetStartedWithFs: "Get started with Fullscript",
  RupaRedirectHeading: "Looking for Rupa Health? You're in the right place.",
  RupaRedirectSubheading:
    "Rupa Health has moved to Fullscript. Choose your account type below to get started.",
  RupaFullscriptLogoAlt: "Rupa Health and Fullscript logo",
  RupaCreateAccountHeading: "Create your free practitioner account",
  RupaCreateAccountSubheading:
    "Fullscript integrates lab ordering into your broader clinical workflow, simplifying ordering, tracking, and practice management in one place.",
  RupaSetUpSignInDetails: "Set up your sign-in details",
  WhichTypeOfAccount: "Which type of account would you like to create?",
  Next: "Next",
  privacyPolicy: "Privacy Policy",
  privacyStatement: "Privacy Statement",
  termsOfSale: "Terms of Sale",
  termsOfServices: "Terms of Service",
  practitionerSignupStepper: {
    step1: "Get started",
    step2: "Create account",
    step3: "Practice info",
    step4: "Credentials",
  },
  CreateAFullscriptAccount: "Create a Fullscript account",
  rupaRedirectInfoPanel: {
    title: "Your account gives you access to:",
    trustedLabs: "1,000+ trusted labs from leading lab partners",
    phlebotomyOptions: "Phlebotomy options to meet your practice's needs",
    ehrIntegrations: "Seamless integrations with top EHR workflows",
    flexibleBilling: "Flexible billing options like patient or provider pay",
    authorizeLabs: "Authorize labs within your clinic or use an external signing clinician network",
    imageAlt: "Rupa Health and Fullscript lab and supplement catalogs",
  },
} as const;
